var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuditView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12815",
    "data-name": "Rectangle 12815",
    width: 60,
    height: 60,
    transform: "translate(1595 1245.825)",
    fill: "#78879b",
    stroke: "#89949b",
    strokeWidth: 1,
    opacity: 0.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1350",
    "data-name": "Mask Group 1350",
    transform: "translate(-1595 -1245.825)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check_1_",
    "data-name": "check (1)",
    transform: "translate(1595.023 1245.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21306",
    "data-name": "Path 21306",
    d: "M7.884,23.3A22.371,22.371,0,0,1,26.854,1.193a22.367,22.367,0,1,0-3.4,44.475,22.532,22.532,0,0,0,3.4-.256A22.371,22.371,0,0,1,7.884,23.3Z",
    transform: "translate(1.616 1.405)",
    fill: "#78879b",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21307",
    "data-name": "Path 21307",
    d: "M24.717,49.415A24.708,24.708,0,1,1,49.424,24.708,24.736,24.736,0,0,1,24.717,49.415Zm0-44.731A20.024,20.024,0,1,0,44.741,24.708,20.046,20.046,0,0,0,24.717,4.684Z",
    transform: "translate(-0.009)",
    fill: "#78879b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21308",
    "data-name": "Path 21308",
    d: "M50.385,49.18a2.335,2.335,0,0,1-1.656-.686l-10.48-10.48A2.342,2.342,0,0,1,41.56,34.7l10.48,10.48a2.342,2.342,0,0,1-1.656,4ZM20.308,20.519l9.255-9.313a2.342,2.342,0,1,0-3.322-3.3L16.984,17.22a2.57,2.57,0,0,1-3.662,0L8.839,12.7A2.342,2.342,0,0,0,5.512,16L10,20.517a7.254,7.254,0,0,0,10.313,0Z",
    transform: "translate(7.227 10.82)",
    fill: "#78879b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditView);
export default __webpack_public_path__ + "static/media/Audit_view.761c16f2ae9c1ca92537540bcfdbddcd.svg";
export { ForwardRef as ReactComponent };